import { createSelector } from "@reduxjs/toolkit";

const selectTestimonialState = (state) => state.testimonial || {};

export const selectTestimonials = createSelector(
  [selectTestimonialState],
  (testimonialState) => testimonialState.testimonials ?? [] // stable reference
);

export const selectSelectedTestimonial = createSelector(
  [selectTestimonialState],
  (testimonialState) => testimonialState.selectedTestimonial ?? null
);

export const selectIsLoading = createSelector(
  [selectTestimonialState],
  (testimonialState) => testimonialState.isLoading ?? false
);
